
import { defineComponent, ref, watch, onMounted } from 'vue';
import prism from '@/vuePrismFiles/index.js';

import { store } from '@/main';
import { computeHighLightNumberHelper } from '@/heplers';

export default defineComponent({
  name: 'Prism',
  components: {
    prism,
  },
  props: {
    language: {
      type: String,
      default: 'javascript',
    },
    highlight: {
      type: Array,
      default: undefined,
    },
  },
  setup(props) {
    const code = ref<HTMLElement | { $el?: HTMLElement } | null>(null);
    const highLightArray = ref<number[]>([]);

    function getCodeEl() {
      const c = code.value;
      return c && ('$el' in c && c.$el ? c.$el : (c as HTMLElement));
    }

    function appendLineNumbers(env: HTMLElement | null | undefined) {
      if (!env?.hasChildNodes() || env.querySelector('.line-numbers-rows')) return;

      const codeEl = env.firstChild as HTMLElement;
      const match = codeEl.innerText.match(/\n(?!$)/g);
      const linesNum = match ? match.length + 1 : 1;
      const lineNumbersWrapper = document.createElement('span');
      const lines = new Array(linesNum + 1).join('<span></span>');

      lineNumbersWrapper.setAttribute('aria-hidden', 'true');
      lineNumbersWrapper.className = 'line-numbers-rows';
      lineNumbersWrapper.innerHTML = lines;

      codeEl.appendChild(lineNumbersWrapper);
    }

    /**
     * Если у нас есть highLight, то проходимся по коду, и строки которые !highlight мы оборачиваем в тег со специальным классом чтобы заблюрить
     */
    function appendBlurLines(codeEl: HTMLElement | null | undefined) {
      if (!codeEl?.hasChildNodes() || !highLightArray.value.length) return;

      const codeFirstChild = codeEl.firstChild as HTMLElement;

      if (!codeFirstChild.innerText.length) return;

      const matched = codeFirstChild.innerHTML.match(/.*\n/g);

      if (!matched) return;

      const newCode = matched.map((value: string, index: number) => {
        if (!highLightArray.value.includes(index + 1))
          return '<span class="blur">' + value + '</span>';
        return value;
      });

      codeFirstChild.innerHTML = newCode.join('');
    }

    function initMethods() {
      highLightArray.value = computeHighLightNumberHelper((props.highlight as string[]) || []);
      const codeEl = getCodeEl();
      appendBlurLines(codeEl);
      appendLineNumbers(codeEl);
    }

    watch(
      () => store.state.pageRendered,
      (isRendered) => {
        if (isRendered) initMethods();
      }
    );

    onMounted(() => {
      initMethods();
    });

    return {
      code,
    };
  },
});
